module.exports = __webpack_public_path__ + "static/img/gongyi_2.57af091.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/news/gongyi_2.png
// module id = PU6u
// module chunks = 0